import module from '../module';

const cartonomyLogo = require('../../../resources/images/cartonomy-icon.svg');

module.directive('cartonomyLogo', [ '$', function ($) {
    return {
        restrict: 'E',
        link: function ($scope, element) {
            $(element).html(cartonomyLogo);
        }
    };
} ]);



// WEBPACK FOOTER //
// ./src/modules/shared/directives/CartonomyLogoDirective.js